require('./stepValidateInteractionId.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash/object/get');
const classNames = require('classnames');
//@utilities
const { formatText } = require('core/i18n').i18n;
const typeDoc = require('utilities/typeDocument');
const { isInOffice } = require('utilities/contactCenter/disasterRecoveryhelper');

//@commons
const { OKInput } = require('commonsComponents/OKInput');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

//@components
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');

// @constants
const { DEFAULT_ORIGIN_COUNTRY } = require('constants/countries');


class StepValidateInteractionId extends React.Component {
    constructor(props) {
        super(props);
        this.handleInteractionIdChange = this.handleInteractionIdChange.bind(this);
        this.handleInteractionIdValidations = this.handleInteractionIdValidations.bind(this);
        this.handleToggleCertificationCheckBox = this.handleToggleCertificationCheckBox.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);

        this.state = {
            certificationCheckBoxValue: false,
            showModal: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.resetCounter !== nextProps.resetCounter && nextProps.resetCounter) {
            this.setState({
                certificationCheckBoxValue: false,
                showModal: false
            });
        }
    }

    getFooterClasses() {
        const inOffice = isInOffice();
        const classes = classNames('step-client-login__footer', {
            'step-client-login__footer--in-office': inOffice
        });

        return classes;
    }

    handleInteractionIdChange(event) {
        const { clearInteractionIdErrorMessage, updateInteractionId } = this.props;

        clearInteractionIdErrorMessage();
        updateInteractionId(event.target.value);
    }

    handleInteractionIdValidations() {
        const { validateInteractionId, interactionId } = this.props;

        validateInteractionId(interactionId);
    }

    handleNextClick() {
        const { handleNext, interactionId } = this.props;
        const { certificationCheckBoxValue } = this.state;
        const isInTheOffice = isInOffice();

        if (isInTheOffice && !certificationCheckBoxValue) {
            this.handleToggleModal();
        } else {
            handleNext(interactionId);
        }
    }

    handleToggleCertificationCheckBox() {
        this.setState({ certificationCheckBoxValue: !this.state.certificationCheckBoxValue });
    }

    handleToggleModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    buildInteractionIdErrorExtraMessage(interactionIdErrorMessage) {
        if (!!interactionIdErrorMessage) {
            return (
                <p className="step-client-login__try-again-message">
                    {formatText('stepClientLogin-tryAgainMessage')}
                </p>
            );
        }

        return null;
    }

    buildCertificationCheckBox() {
        const checkboxLabel = formatText("stepClientLogin-certificationCheckBox");

        return (
            <div className="step-client-login__certification-checkbox">
                <OKCheckbox
                    idName="certificationCheckBox"
                    disabled={false}
                    label={checkboxLabel}
                    value={this.state.certificationCheckBoxValue}
                    onChange={this.handleToggleCertificationCheckBox}
                />
            </div>
        );
    }

    buildCertificationModal() {
        const certificationModalTitle = formatText("stepClientLogin-certificationModalTitle");
        const certificationModalText = formatText("stepClientLogin-certificationModalText");
        const okButtonLabel = formatText("common-ok");

        return (
            <PreleaveCancelModal
                confirmTitle={certificationModalTitle}
                cancelButtonLabel={okButtonLabel}
                isOpen={this.state.showModal}
                onCancel={this.handleToggleModal}
                onCloseModal={this.handleToggleModal}
            >
                <i className="icon-error step-client-login__modal-content-icon"></i>
                <span className="step-client-login__modal-content-text">
                    {certificationModalText}
                </span>
            </PreleaveCancelModal>
        );
    }

    render() {
        const {
            immStepValidateInteractionId,
            immClientIdentification,
            stepNo,
            interactionId,
            country,
        } = this.props;

        const clientData = immClientIdentification.toJS();
        const titleText = formatText("stepValidateInteractionId-title");
        const fullNameText = formatText("stepClientLogin-fullName");
        const documentTypeText = formatText("stepClientLogin-documentType");
        const documentNumberText = formatText("stepClientLogin-documentNumber");
        const verifyMessageText = formatText("stepClientLogin-verifyMessage");
        const interactionIdLabel = formatText("stepClientLogin-clientIdentifierInputLabel");
        const buttonNextText = formatText('sendOtpStep-sendOtpCodeButton');
        const tooltipInfo = formatText("stepClientLogin-infoPhysicalOfficeOnly");

        const fullName = get(clientData, 'documento.nombre', '--');
        const documentTypeCode = get(clientData, 'documento.documento.tipodocumpersonacorp');
        const documentType = documentTypeCode ? typeDoc.getLabel(documentTypeCode.trim(), country).label : '--';
        const documentNumber = get(clientData, 'documento.documento.codigodocumpersonacorp', '--');

        const interactionIdErrorMessage = immStepValidateInteractionId.get('interactionIdErrorMessage');
        const extraMessageInteraction = this.buildInteractionIdErrorExtraMessage(interactionIdErrorMessage);

        const isLoading = immStepValidateInteractionId.get('isFetching');

        const footerClasses = this.getFooterClasses();
        const inOfficeCertificationCheckBox = isInOffice() ? this.buildCertificationCheckBox() : null;
        const buttonsClassNames = classNames('step-client-login__buttons', { 'step-client-login__buttons--in-office': isInOffice() });
        const certificationModal = isInOffice() ? this.buildCertificationModal() : null;

        const info = (
            <OKTooltip
                customClass="step-validate-interaction-id__tooltip"
                target={
                    <i className="icon-informacion"></i>
                }
                content={tooltipInfo}
                placement="bottom"
            />
        );

        return (
            <div className="step-validate-interaction-id">
                {certificationModal}
                <div className="step-validate-interaction-id__header">
                    <span className="wizard-step--vertical__progress-indicator">
                        {stepNo}
                    </span>
                    <h4 className="wizard-step--vertical__title step-validate-interaction-id__title">
                        {titleText}
                    </h4>
                </div>

                <div className="step-validate-interaction-id__body">
                    <div className="step-validate-interaction-id__out-office-block">
                        <div className="step-validate-interaction-id__first-column">
                            <span className="step-validate-interaction-id__label">
                                {fullNameText}
                            </span>
                            <span className="step-validate-interaction-id__info">
                                {fullName}
                            </span>
                            <span className="step-validate-interaction-id__verify-message-text">
                                {verifyMessageText}
                            </span>
                            {info}
                        </div>
                        <div className="step-validate-interaction-id__middle-column">
                            <span className="step-validate-interaction-id__label">
                                {documentTypeText}
                            </span>
                            <span className="step-validate-interaction-id__info">
                                {documentType}
                            </span>
                            <span className="step-validate-interaction-id__label">
                                {documentNumberText}
                            </span>
                            <span className="step-validate-interaction-id__info">
                                {documentNumber}
                            </span>
                        </div>
                        <div className="step-validate-interaction-id__last-column">
                            <OKInput
                                value={interactionId}
                                onBlur={this.handleInteractionIdValidations}
                                onChange={this.handleInteractionIdChange}
                                label={interactionIdLabel}
                                errorState={!!interactionIdErrorMessage}
                                errorMessage={interactionIdErrorMessage}
                            />
                            {extraMessageInteraction}
                        </div>
                    </div>
                </div>
                <div className={footerClasses}>
                    {inOfficeCertificationCheckBox}
                    <div className={buttonsClassNames}>
                        <OKButton
                            modifier="secondary"
                            onClick={this.handleNextClick}
                            rightIcon="icon-siguiente"
                            loading={isLoading}
                        >
                            {buttonNextText}
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }
}

StepValidateInteractionId.propTypes = {
    immStepValidateInteractionId: PropTypes.object.isRequired,
    stepNo: PropTypes.number.isRequired,
    handleNext: PropTypes.func.isRequired,
    resetCounter: PropTypes.number.isRequired,
    immClientIdentification: PropTypes.object.isRequired,
    validateInteractionId: PropTypes.func.isRequired,
    clearInteractionIdErrorMessage: PropTypes.func.isRequired,
    updateInteractionId: PropTypes.func.isRequired,
    interactionId: PropTypes.string.isRequired,
    country: PropTypes.string,
}

StepValidateInteractionId.defaultProps = {
    country: DEFAULT_ORIGIN_COUNTRY,
};

module.exports = StepValidateInteractionId;
